<template>
  <div class="pageBody">
    <slot />
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
}
</script>

<style scoped>
.pageBody {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  font-family: Roboto;
  color: #121212;
  background-color: #efefef;
  align-self: stretch;
  flex-grow: 1;
}
html {
  position: relative;
  min-height: 100%;
}
body {
  width: 100%;
  padding: 0;
  margin: 0;
}
</style>

<style>
.noSense {
}
</style>